import { render, staticRenderFns } from "./CustomFieldsMultiselectModal.vue?vue&type=template&id=3ab2e222&"
import script from "./CustomFieldsMultiselectModal.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsMultiselectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports